import "core-js/modules/es6.number.constructor";
import { sizes } from "../../mixins/size.js";
import ListenersMixin from "../../mixins/listeners.js";
export default {
  mixins: [ListenersMixin],
  props: {
    color: String,
    size: {
      type: [Number, String],
      default: '1em'
    }
  },
  computed: {
    cSize: function cSize() {
      return this.size in sizes ? "".concat(sizes[this.size], "px") : this.size;
    },
    classes: function classes() {
      if (this.color) {
        return "text-".concat(this.color);
      }
    }
  }
};